<template>
  <div class="bm-apply-done" >
    <div style="width: 100%; height: 80px;" ></div>
    <div class="code" >
      <div class="title" >提交成功</div>
      <img src="@/assets/images/bmb.jpg" >
      <p>关注斑马邦体育，获取</p>
      <p>赛事资讯 场上数据 比赛视频</p>
      <img v-if="advertising" class="Advertising" src="">
      <div class="off" @click="code = false" >
        <van-icon name="cross" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { Cell } from 'vant'

Vue.use(Cell)

export default {
  name: 'teamEdit',
  data() {
    return {
      isShowName: false,
      advertising: false
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="stylus">
.bm-apply-done
  width 100%
  height: 100%;
  background-color: #32A377;
  background-image url('../../assets/images/bmb-bg.png')
  background-size 90%
  position relative
  .code
    background-color white
    padding: 15px;
    width calc(100% - 70px )
    margin auto
    ox-shadow:0px 2px 15px 0px rgba(27,98,70,0.06);
    border-radius:15px;
    text-align center
    position absolute
    top: 45%
    left: 50%
    transform translate(-50%, -50%)
    .title
      font-size:28px;
      font-family:PingFangSC-Semibold;
      font-weight:600;
      color:rgba(50,163,119,1);
    .title+img
      width 120px
      height: 120px
    p
      font-size:16px;
      font-weight:400;
      color:rgba(74,74,74,1);
      line-height:22px;
      margin: 0;
    .Advertising
      padding-top 10px
      width 100%
      height: 90px
    .off
      display none
      content: ""
      position absolute
      width: 50px
      height: 50px
      background:rgba(255,255,255,1);
      opacity:0.7979;
      bottom -70px
      border-radius 50%
      left 50%
      transform translate(-50%, 0)
      .van-icon
        text-align center
        line-height 50px
        font-size: 30px
        color #000000
</style>



// WEBPACK FOOTER //
// src/pages/invite/apply-done.vue